var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavProductCatalog = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.876 7.07c.06.172.102.351.123.535v6.884a1.25 1.25 0 0 1-.647.913l-5.819 3.076a3.741 3.741 0 0 1-.985.278v-7.949l7.328-3.737ZM9.401 10.78v7.954a3.748 3.748 0 0 1-1.106-.373l-5.635-2.96A1.249 1.249 0 0 1 2 14.407V7.707c.018-.232.067-.457.146-.67L9.4 10.78ZM12.976 8.292 10 9.809 2.772 6.081a2.5 2.5 0 0 1 .36-.282l.144-.087 2.26-1.258 7.44 3.838ZM9.016 2.53a2.5 2.5 0 0 1 1.747-.113l4.369 2.387 1.61.906.143.088a2.5 2.5 0 0 1 .382.307l-3.042 1.551L6.73 3.79l1.561-.868.725-.392Z"
})));
SvgNavProductCatalog.displayName = "SvgNavProductCatalog";
export { SvgNavProductCatalog as ReactComponent };
export default SvgNavProductCatalog;